import {
  REQUIRED_BACKUP_FIELDS,
  RequiredBackupField,
  WalkthroughBackupFileContents,
} from './useWalkthroughBackupUpload';

export type ValidationResult =
  | {
      success: true;
      data: WalkthroughBackupFileContents;
    }
  | {
      success: false;
      reason: 'invalid-json';
      errorDetail: string;
    }
  | {
      success: false;
      reason: 'missing-fields';
      missingFields: RequiredBackupField[];
    };

const extractUUID = (fieldName: string, rawSlice: string): string | null => {
  const uuidPattern =
    '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
  const match: RegExpMatchArray = rawSlice.match(
    new RegExp(`"${fieldName}"\\s*:\\s*"(${uuidPattern})"`)
  );

  return match?.[1] ?? null;
};

const extractString = (fieldName: string, rawSlice: string): string | null => {
  const match: RegExpMatchArray = rawSlice.match(
    new RegExp(`"${fieldName}"\\s*:\\s*"([^"]+)"`)
  );

  return match?.[1] ?? null;
};

export const parseAndValidateBackupFile = (
  rawSlice: string
): ValidationResult => {
  const walkthroughId: string = extractUUID('walkthroughId', rawSlice);
  const propertyId: string = extractUUID('propertyId', rawSlice);
  const suiteId: string = extractUUID('suiteId', rawSlice);
  const status: string = extractString('status', rawSlice);

  const missingFields = REQUIRED_BACKUP_FIELDS.filter(
    (field: 'walkthroughId' | 'propertyId' | 'suiteId' | 'status') => {
      const values: Record<string, string | null> = { walkthroughId, propertyId, suiteId, status };
      return !values[field];
    }
  );

  if (missingFields.length > 0) {
    return { success: false, reason: 'missing-fields', missingFields };
  }

  return {
    success: true,
    data: {
      walkthroughId: walkthroughId!,
      propertyId: propertyId!,
      suiteId: suiteId!,
      status: status!,
    },
  };
};
